import { Component, h } from '@stencil/core';
import { _BREAKPOINTS_ } from 'utils';
import { ImageLoader } from 'global/image-loader';
import { AppFormsValidator } from './app-forms-validator';

declare global {
  interface Window { imageLoader: any; }
}

declare var assetPath;

@Component({
  tag: 'st-app',
  shadow: false
})
export class StApp {

  componentWillLoad() {
    globalThis.imageLoader = new ImageLoader();
    this.addListItemBullets();
    this.homeHeroCtaHover();
    this.leftRailMobileToggle();
    globalThis.appFormsValidator = new AppFormsValidator();
  }

  componentDidLoad() {
    globalThis.imageLoader.initialize();
    globalThis.appFormsValidator.initialize();
  }

  componentDidRender() {
    setTimeout(() => {
      var hash = window.location.hash;
      if (hash) {
        var elem = document.getElementById(hash.substring(1));
        if (elem) {
          elem.scrollIntoView();
        }
      }
    }, 500);
  }

  addListItemBullets() {
    document.head.insertAdjacentHTML("beforeend", `<style>ul li:before {
      background-image: url("${assetPath}/icon/check.svg");
    }</style>`);
  }

  homeHeroCtaHover() {
    const homeHeroCtas = document.querySelector('.home-hero__ctas');

    if(homeHeroCtas != null) {

      homeHeroCtas.addEventListener('mouseover', () => {
          homeHeroCtas.classList.add('is-hovering');
      });
  
      homeHeroCtas.addEventListener('mouseout', () => {
          homeHeroCtas.classList.remove('is-hovering');
      });
    }

  }

  leftRailMobileToggle() {
    const railNav = document.querySelector('.left-rail-nav');
    const railNavToggler = document.querySelector('.left-rail-nav__toggler');


    if (railNav && railNavToggler != null) {

      railNavToggler.addEventListener('click', () => {
        if (railNav.classList.contains('open')) {
          railNav.classList.remove('open');
          railNavToggler.setAttribute('aria-expanded', 'false');
        } else {
          railNav.classList.add('open');
          railNavToggler.setAttribute('aria-expanded', 'true');
        }
      });

      document.addEventListener('click', (event) => {
        const target = event.target as Node;
        if (!railNav.contains(target)) {
          railNav.classList.remove('open');
          railNavToggler.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  render() {
    return (
      <div class="app-global">
        <slot />
      </div>
    )
  }
}
